import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import { NavDropdown } from "react-bootstrap";
import Searchbar from "../SearchBar/SearchBar";

import HeaderLinks from "../Header/HeaderLinks.jsx";

import imagine from "../../assets/img/sidebar-4.jpg";

import dashboardRoutes from "../../routes/dashboard.jsx";

import "./Sidebar.css";

class Sidebar extends Component {
  constructor() {
    super();
    this.state = {
      width: document.querySelector('body').offsetWidth,
    };
  }
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  updateDimensions() {
    this.setState({ width: document.querySelector('body').offsetWidth });
  }
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }
  render() {
    const sidebarBackground = {
      backgroundImage: "url(" + imagine + ")",
    };

    if (window.location.host == "salavirtual.sambalms.com.br") {
      return <div></div>;
    }

    return (
      <div
        id="sidebar"
        className="sidebar"
        data-color="black"
        data-image={imagine}
      >
        <div className="sidebar-background" style={sidebarBackground}></div>
        <div className="sidebar-wrapper">
          <ul className="nav">
            <div className="sidebar-close">
              <FaTimes
                onClick={() =>
                  document.documentElement.classList.remove("nav-open")
                }
              />
            </div>
            {this.state.width <= 991 && <HeaderLinks />}
            {dashboardRoutes.map((prop, key) => {
              if (!prop.redirect && prop.showSidebar)
                if (prop.children) {
                  return (
                    <li
                      className={
                        prop.upgrade
                          ? "active active-pro"
                          : this.activeRoute(prop.path)
                      }
                      key={key}
                    >
                      <NavDropdown
                        title={prop.name}
                        className="nav-link"
                        activeClassName="active"
                      >
                        {prop.children.map((prop, key) => {
                          return (
                            <NavLink
                              to={prop.path}
                              className="nav-link"
                              activeClassName="active"
                            >
                              <p>{prop.name}</p>
                            </NavLink>
                          );
                        })}
                      </NavDropdown>
                    </li>
                  );
                } else {
                  return (
                    <li
                      className={
                        prop.upgrade
                          ? "active active-pro"
                          : this.activeRoute(prop.path)
                      }
                      key={key}
                    >
                      <NavLink
                        to={prop.path}
                        className="nav-link"
                        activeClassName="active"
                        data-gtm-type="click"
                        data-gtm-clicktype="button"
                        data-gtm-name={prop.name}
                      >
                        <p>{prop.name}</p>
                      </NavLink>
                    </li>
                  );
                }
            })}
          </ul>
          {this.state.width <= 991 && <Searchbar />}
        </div>
      </div>
    );
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.jsx